/**
 * Clamp a tooltip's x position so it stays within the viewport.
 *
 * @param x        – the intended left edge (or center if centerBased)
 * @param tipWidth – estimated tooltip width in px
 * @param centerBased – if true, the tooltip uses transform: translateX(-50%)
 *                     so x is the centre anchor, not the left edge
 * @returns        – adjusted x that keeps the tooltip within bounds
 */
export function clampTooltipX(
  x: number,
  tipWidth: number,
  centerBased = false,
): number {
  const PAD = 8;

  if (centerBased) {
    // x is the centre → left edge = x - tipWidth/2
    let left = x - tipWidth / 2;
    if (left < PAD) left = PAD;
    if (left + tipWidth > window.innerWidth - PAD) {
      left = window.innerWidth - tipWidth - PAD;
    }
    return left + tipWidth / 2; // return adjusted centre
  }

  // x is the left edge
  let left = x;
  if (left + tipWidth > window.innerWidth - PAD) {
    left = window.innerWidth - tipWidth - PAD;
  }
  if (left < PAD) left = PAD;
  return left;
}
